import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const BotonVolver = ({ to, label }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      className="inline-flex items-center gap-2 text-sm font-extrabold text-gray-600 hover:text-yellow-600 bg-white/95 border border-gray-200 hover:border-yellow-400 px-3 py-1.5 rounded-full shadow-sm transition-colors"
    >
      <FaArrowLeft className="text-xs" />
      {label}
    </button>
  );
};

export default BotonVolver;
